/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ProductListing.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page - Individual product listing code.
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H224423
*
* @Date		    : Sep 23, 2019
*
* @Version      : Version 1.0
*
* By            : H224423
* On            : Sep 23, 2019
* Description   : ASDS-937 - Product Listing APU changes.
*
 * By            	: Madhu Gali - H175591
 * On            	: Oct 10, 2019
 * Description   : ASDS-1476
 *
 * By            : SandeepRaja
 * On            : Oct 31, 2019
 * Description   : ASDS-1672: Empty Product Search UI & Integration
 *
 * By            : E844276
 * On            : Nov 18, 2019
 * Description   : Added generic product functionalities - removed from products
 *
 * By            : H224423
 * On            : Sep 23, 2019
 * Description   : Removed product category check.
 *
 * By            : Suresh Jaladi - E807958
 * On            : Dec 06, 2019
 * Description   : ASDS-1811
 *
 * By            	: Snigdha
 * On            	: Feb 10, 2019
 * Description      : ASDS-2268
 *
 * By            : H422336
 * On            : Sep 7 2020
 * Description   : ASDS-2748 - UI Enhancements as part of Phase II
 *
******************************************************************************/
import React from 'react';
import { connect } from 'react-redux';
import ConfigureProduct from '../../ConfigureProduct/ConfigureProduct';
import { CheckoutUILabels } from '../../constants/checkout-constants';
import ConfigureProductActions from '../../redux/actions/configure-product-actions';
import InCompatibleProductsAlert from '../InCompatibleProductsAlert';
import GenericLoader from '../../Loader/Loader';
import ProductListingLoader from './ProductListingLoader';
import ConfigureAPU from '../../ConfigureAPU/ConfigureAPU';
import NoProductsFound from './NoProductsFound';
import ListProducts from './ListProducts';
import { CategoryListing } from '..';
import ConfigureAPUActions from 'modules/checkout/redux/actions/configure-apu-actions';
import ProductListingHeader from '../ProductListingHeader';

import ConfigureWirelessProduct from 'modules/checkout/Products/Wireless/ConfigureWirelessProduct';
import ConfigureWirelessActions from '../../redux/actions/configure-wireless-actions';
import ProductAlertActions from 'modules/checkout/redux/actions/products-alerts-action';
import InvalidWirelessProduct from 'modules/checkout/Products/Wireless/InvalidWirelessProduct';

interface ProductListingPropsI {
    products?: {
        productListing: {
            data: {
                categories: CategoryListing[],
                matchedAny?: boolean,
            }
            isFetching: boolean,
            isSuccess: boolean,
            error: {},
        },
        selectedCategory: string,
    };
    productName: string;
    apuproductName: string;
    onClickConfigureButton: any;
    onClickAPUConfigureButton: any;
    configureModelOpen: any;
    configureAPUModelOpen: any;
    showAlertMsg: boolean;
    hideAlert: Function;
    productId: string;
    apuProductId: string;
    inCompatibleProducts: boolean;
    closeInCompatibleProductsAlert: Function;
    addToCartButtonClicked: Function;
    isApptusProductsAddedToCart: boolean;
    isBMSProductsAddedToCart: boolean;
    addProductToCartInProgress: boolean;
    wirelessProductId: string;
    wirelessProductName: string;
    configureWirelessModelOpen: any;
    wirelessProductPrice: number;
    invalidProducts: boolean;
    closeInvalidProducts: Function;
    wirelessIncompatproductId:string;
}

function ProductListingInit(props: ProductListingPropsI) {
    if (props.products && !props.products.productListing.isFetching && props.products.productListing.error) {
        return <NoProductsFound title={CheckoutUILabels.PRODUCTS_LOADING_ERROR}
            message="If the issue persists," />;
    }
    else if (props.products && props.products.productListing.isFetching) {
        return <ProductListingLoader />;
    } else if (props.products && props.products.productListing &&
        props.products.productListing.data &&
        props.products.productListing.data.hasOwnProperty('matchedAny') &&
        !props.products.productListing.data.matchedAny
    ) {
        // case for search results, result comming from seach API has key matchedAny.
        return <NoProductsFound title={CheckoutUILabels.PRODUCTS_NOT_FOUND_FOR_SEARCH} message="If you need help," />;
    } else if (props.products && props.products.productListing &&
        props.products.productListing.data &&
        props.products.productListing.data.categories &&
        props.products.productListing.data.categories.length === 0) {
        return <NoProductsFound title={CheckoutUILabels.PRODUCTS_NOT_FOUND} message="If you need help," />;
    } else {
        return (
            <React.Fragment>
                <ProductListingHeader />
                <ListProducts
                    categories={props.products ? props.products.productListing.data.categories : []}
                    selectedCategory={props.products ? props.products.selectedCategory : ''}
                    onClickConfigureButton={props.onClickConfigureButton}
                    configureModelOpen={props.configureModelOpen}
                    configureAPUModelOpen={props.configureAPUModelOpen}
                    configureWirelessModelOpen={props.configureWirelessModelOpen}
                    onClickAPUConfigureButton={props.onClickAPUConfigureButton}
                    showAlertMsg={props.showAlertMsg}
                    hideAlert={props.hideAlert}
                    addToCartButtonClicked={props.addToCartButtonClicked}
                />
                {props.configureModelOpen && props.productName &&
                    <ConfigureProduct open={props.configureModelOpen} productId={props.productId} productName={props.productName} />}

                {props.configureAPUModelOpen && props.apuproductName &&
                    <ConfigureAPU open={props.configureAPUModelOpen} productId={props.apuProductId} productName={props.apuproductName} />}

                {props.inCompatibleProducts &&
                    <InCompatibleProductsAlert
                        open={props.inCompatibleProducts}
                        onClose={props.closeInCompatibleProductsAlert}
                        AlertHeader={'Unable To Add Product To Your Cart!'}
                        AlertMsg={'Please complete the purchase or clear the items in your cart'}
                        AlertDescription={props.isBMSProductsAddedToCart ? CheckoutUILabels.NOT_ABLE_TO_ADD_APPTUS_PRODUCT_ALERT_MSG : CheckoutUILabels.NOT_ABLE_TO_ADD_BMS_PRODUCT_ALERT_MSG
                        }
                    />
                }

                {props.invalidProducts &&
                    <InvalidWirelessProduct
                        open={props.invalidProducts}
                        onClose={props.closeInvalidProducts}
                        productId= {props.wirelessIncompatproductId}
                    />
                }

                {props.configureWirelessModelOpen &&
                    <ConfigureWirelessProduct
                        open={props.configureWirelessModelOpen}
                        wirelessProductName={props.wirelessProductName}
                        wirelessProductId={props.wirelessProductId}
                        wirelessProductPrice={props.wirelessProductPrice} />}

                {props.addProductToCartInProgress && <GenericLoader text="Adding to Cart" className="add-to-cart--loader" loading={true} overlayColor="rgb(247, 247, 247)" />}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const { productListing = {}, selectedCategory = {} } = state.products.payload;
    return {
        products: { productListing, selectedCategory },

        showAlertMsg: state.productAlertData.payload.showAlertMsg,
        inCompatibleProducts: state.productAlertData.payload.inCompatibleProducts,
        isApptusProductsAddedToCart: state.productAlertData.payload.isApptusProductsAddedToCart,
        isBMSProductsAddedToCart: state.productAlertData.payload.isBMSProductsAddedToCart,
        addProductToCartInProgress: state.productAlertData.payload.addProductToCartInProgress,

        configureModelOpen: state.configProductData.payload.configureModelOpen,
        productId: state.configProductData.payload.product.productId,
        productName: state.configProductData.payload.product.productName,

        configureAPUModelOpen: state.configAPUData.payload.configureAPUModelOpen,
        apuProductId: state.configAPUData.payload.product.productId,
        apuproductName: state.configAPUData.payload.product.productName,

        wirelessProductId: state.configWirelessProductData.payload.product.productId,
        wirelessProductName: state.configWirelessProductData.payload.product.productName,
        configureWirelessModelOpen: state.configWirelessProductData.payload.configureWirelessModelOpen,
        wirelessProductPrice: state.configWirelessProductData.payload.product.price,
        invalidProducts: state.productAlertData.payload.invalidProducts,
        wirelessIncompatproductId: state.productAlertData.payload.productId
    };
}

const mapDispatchToProps = {
    hideAlert: ProductAlertActions.hideAlert,
    closeInCompatibleProductsAlert: ProductAlertActions.closeInCompatibleProductsAlert,
    onClickConfigureButton: ConfigureProductActions.onClickConfigureButton,
    onClickAPUConfigureButton: ConfigureAPUActions.onClickAPUConfigureButton,
    addToCartButtonClicked: ConfigureWirelessActions.onClickAddToCartButton,
    closeInvalidProducts: ProductAlertActions.closeInValidProductsAlert,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductListingInit);